import configHelper from '@/config/ConfigHelper'
import Modulos from '../classes/enums/Modulos'
import { i18n } from '@/i18n'


function GenerateCabecerasModulos () {
  return [
    { id: 1, Nombre: i18n.t('tipos.cabecera_modulo_name.issued_invoices') },
    { id: 2, Nombre: i18n.t('tipos.cabecera_modulo_name.grouping_distribution') },
    { id: 3, Nombre: i18n.t('tipos.cabecera_modulo_name.personalization') },
    { id: 4, Nombre: i18n.t('tipos.cabecera_modulo_name.received_invoices') },
    { id: 5, Nombre: i18n.t('tipos.cabecera_modulo_name.webhooks') },
    { id: 6, Nombre: i18n.t('tipos.cabecera_modulo_name.authentication') },
  ]
}

function GenerateModulos () {
  return [
    { id: Modulos.GLOBAL, Nombre: i18n.t('tipos.modulo_name.global') },
    { id: Modulos.INTEGRACION_OCR, Nombre: i18n.t('tipos.modulo_name.ocr') },
    { id: Modulos.INTEGRACION_ERP, Nombre: i18n.t('tipos.modulo_name.erp') },
    { id: Modulos.AUTO_FACTURA, Nombre: i18n.t('tipos.modulo_name.autofactura') },
    { id: Modulos.WEBHOOKS_EMITIDAS, Nombre: i18n.t('tipos.modulo_name.webhooks_issued_invoices') },
    { id: Modulos.WEBHOOKS_RECIBIDAS, Nombre: i18n.t('tipos.modulo_name.webhooks_received_invoices') },
    { id: Modulos.APROBACION_FACTURAS, Nombre: i18n.t('tipos.modulo_name.approving_invoices') },  
    { id: Modulos.GENERACION_FACTURAS_PDF, Nombre: i18n.t('tipos.modulo_name.pdf_invoice') },
    { id: Modulos.TICKETBAI_BATUZ, Nombre: i18n.t('tipos.modulo_name.tbai') },
    { id: Modulos.INTEGRACION_AAD, Nombre: i18n.t('tipos.modulo_name.aad_integration') },
    { id: Modulos.INTERFAZ_EMISION, Nombre: i18n.t('tipos.modulo_name.emission_interface') },
    { id: Modulos.EMISION_FACTURAS, Nombre: i18n.t('tipos.modulo_name.sending_invoices') },
    { id: Modulos.RECEPCION_FACTURAS, Nombre: i18n.t('tipos.modulo_name.receiving_invoices') },
    { id: Modulos.AGRUPACIONES, Nombre: i18n.t('tipos.modulo_name.grouping') },
    { id: Modulos.CUENTA_CORREO_ZC, Nombre: i18n.t('tipos.modulo_name.zc_smtp') },
    { id: Modulos.CUENTA_CORREO_CLIENTE, Nombre: i18n.t('tipos.modulo_name.custom_smtp') },
    { id: Modulos.CORREOS_AVISOS_PERSONALIZADOS, Nombre: i18n.t('tipos.modulo_name.personalization_emails') },
    { id: Modulos.LOGO_PERSONALIZADO, Nombre: i18n.t('tipos.modulo_name.personalization_logos') },
    { id: Modulos.COLORES_PERSONALIZADOS, Nombre: i18n.t('tipos.modulo_name.personalization_colors') },
    { id: Modulos.INTEGRACION_SAML2, Nombre: i18n.t('tipos.modulo_name.saml2_integration') },
    { id: Modulos.VERIFACTU, Nombre: i18n.t('tipos.modulo_name.verifactu') },
    { id: Modulos.FACTURAS_RECURRENTES, Nombre: i18n.t('tipos.modulo_name.recurring_invoices') },
    { id: Modulos.INFORMES, Nombre: i18n.t('tipos.modulo_name.reports') },
    { id: Modulos.IMPORTACIONES, Nombre: i18n.t('tipos.modulo_name.imports') },
  ]
}

function GenerateTiposEstado () {
  return [
    {
      id: 0,
      Nombre: i18n.t('tipos.estado_emitidas.not_sent'),
      Info: i18n.t('tipos.estado_emitidas.not_sent_info'),
      Modulo: [11],
      Regla: true,
    },
    {
      id: 1,
      Nombre: i18n.t('tipos.estado_emitidas.shipping_order'),
      Info: i18n.t('tipos.estado_emitidas.shipping_order_info'),
      Modulo: [11],
      Regla: true,
    },
    {
      id: 2,
      Nombre: i18n.t('tipos.estado_emitidas.sent'),
      Info: i18n.t('tipos.estado_emitidas.sent_info'),
      Modulo: [11],
      Regla: true,
    },
    {
      id: 3,
      Nombre: i18n.t('tipos.estado_emitidas.rcf'),
      Info: i18n.t('tipos.estado_emitidas.rcf_info'),
      Modulo: [11],
      Regla: false,
    },
    {
      id: 4,
      Nombre: i18n.t('tipos.estado_emitidas.accepted'),
      Info: i18n.t('tipos.estado_emitidas.accepted_info'),
      Modulo: [11],
      Regla: true,
    },
    {
      id: 5,
      Nombre: i18n.t('tipos.estado_emitidas.accounted_for'),
      Info: i18n.t('tipos.estado_emitidas.accounted_for_info'),
      Modulo: [11],
      Regla: true,
    },
    {
      id: 6,
      Nombre: i18n.t('tipos.estado_emitidas.rejected'),
      Info: i18n.t('tipos.estado_emitidas.rejected_info'),
      Modulo: [11],
      Regla: false,
    },
    {
      id: 7,
      Nombre: i18n.t('tipos.estado_emitidas.paid'),
      Info: i18n.t('tipos.estado_emitidas.paid_info'),
      Modulo: [11],
      Regla: true,
    },
    {
      id: 8,
      Nombre: i18n.t('tipos.estado_emitidas.canceled'),
      Info: i18n.t('tipos.estado_emitidas.canceled_info'),
      Modulo: [11],
      Regla: false,
    },
    {
      id: 9,
      Nombre: i18n.t('tipos.estado_emitidas.error'),
      Info: i18n.t('tipos.estado_emitidas.error_info'),
      Modulo: [11],
      Regla: false,
    },
    {
      id: 10,
      Nombre: i18n.t('tipos.estado_emitidas.temporal'),
      Info: i18n.t('tipos.estado_emitidas.temporal_info'),
      Modulo: [11],
      Regla: false,
    },
    {
      id: 11,
      Nombre: i18n.t('tipos.estado_emitidas.duplicated'),
      Info: i18n.t('tipos.estado_emitidas.duplicated_info'),
      Modulo: [11],
      Regla: false,
    },
    {
      id: 21,
      Nombre: i18n.t('tipos.estado_emitidas.external'),
      Info: i18n.t('tipos.estado_emitidas.external_info'),
      Modulo: [11],
      Regla: false,
    },
    {
      id: 26,
      Nombre: i18n.t('tipos.estado_emitidas.quotation'),
      Info: i18n.t('tipos.estado_emitidas.quotation_info'),
      Modulo: [11],
      Regla: false,
    },
    {
      id: 27,
      Nombre: i18n.t('tipos.estado_emitidas.accepted_quotation'),
      Info: i18n.t('tipos.estado_emitidas.accepted_quotation_info'),
      Modulo: [11],
      Regla: false,
    },
    {
      id: 28,
      Nombre: i18n.t('tipos.estado_emitidas.proforma'),
      Info: i18n.t('tipos.estado_emitidas.proforma_info'),
      Modulo: [11],
      Regla: false,
    },
    {
      id: 29,
      Nombre: i18n.t('tipos.estado_emitidas.invoiced'),
      Info: i18n.t('tipos.estado_emitidas.invoiced_info'),
      Modulo: [11],
      Regla: false,
    },
    {
      id: 30,
      Nombre: i18n.t('tipos.estado_emitidas.pf_canceled'),
      Info: i18n.t('tipos.estado_emitidas.pf_canceled_info'),
      Modulo: [11],
      Regla: false,
    },
  ]
}

function GenerateTiposEstadoRecepcion () {
  return [
    {
      id: 12,
      Nombre: i18n.t('tipos.estado_recibidas.ocr'),
      Info: i18n.t('tipos.estado_recibidas.ocr_info'),
      Modulo: [1],
      Regla: false,
    },
    {
      id: 13,
      Nombre: i18n.t('tipos.estado_recibidas.wait_erp_sent'),
      Info: i18n.t('tipos.estado_recibidas.wait_erp_sent_info'),
      Modulo: [2],
      Regla: true,
    },
    {
      id: 14,
      Nombre: i18n.t('tipos.estado_recibidas.wait_erp_response'),
      Info: i18n.t('tipos.estado_recibidas.wait_erp_response_info'),
      Modulo: [2],
      Regla: false,
    },
    {
      id: 15,
      Nombre: i18n.t('tipos.estado_recibidas.wait_accounted_for'),
      Info: i18n.t('tipos.estado_recibidas.wait_accounted_for_info'),
      Modulo: [1, 12],
      Regla: true,
    },
    {
      id: 16,
      Nombre: i18n.t('tipos.estado_recibidas.accounted_for'),
      Info: i18n.t('tipos.estado_recibidas.accounted_for_info'),
      Modulo: [12],
      Regla: true,
    },
    {
      id: 17,
      Nombre: i18n.t('tipos.estado_recibidas.rejected'),
      Info: i18n.t('tipos.estado_recibidas.rejected_info'),
      Modulo: [12],
      Regla: true,
    },
    {
      id: 18,
      Nombre: i18n.t('tipos.estado_recibidas.paid'),
      Info: i18n.t('tipos.estado_recibidas.paid_info'),
      Modulo: [12],
      Regla: true,
    },
    {
      id: 19,
      Nombre: i18n.t('tipos.estado_recibidas.wait_approving'),
      Info: i18n.t('tipos.estado_recibidas.wait_approving_info'),
      Modulo: [6],
      Regla: true,
    },
    {
      id: 20,
      Nombre: i18n.t('tipos.estado_recibidas.duplicated'),
      Info: i18n.t('tipos.estado_recibidas.duplicated_info'),
      Modulo: [12],
      Regla: false,
    }
  
  ]
}

function GenerateTiposVerifactu () {
  return [
    {
      id: 22,
      Nombre: i18n.t('excels.success'),
      Info: i18n.t('verifactu.state.info_succes'),
      Modulo: [31],
      Regla: false,
    },
    {
      id: 23,
      Nombre: i18n.t('verifactu.state.error_accepted'),
      Info: i18n.t('verifactu.state.info_accepted'),
      Modulo: [31],
      Regla: true,
    },
    {
      id: 24,
      Nombre: i18n.t('verifactu.state.wrong'),
      Info: i18n.t('verifactu.state.info_wrogn'),
      Modulo: [31],
      Regla: false,
    },
    {
      id: 25,
      Nombre: i18n.t('verifactu.state.pending'),
      Info: i18n.t('verifactu.state.info_pending'),
      Modulo: [31],
      Regla: true,
    },
  ]
}

function GenerateTiposAccion () {
  return [
    {
      id: 1,
      Nombre: i18n.t('tipos.accion.send'),
      Modulo: [11],
    },
    {
      id: 2,
      Nombre: i18n.t('tipos.accion.retry'),
      Modulo: [11],
    },
    {
      id: 3,
      Nombre: i18n.t('tipos.accion.delete'),
      Modulo: [0],
    },
    {
      id: 4,
      Nombre: i18n.t('tipos.accion.move_to_sent'),
      Modulo: [11],
    },
    {
      id: 5,
      Nombre: i18n.t('tipos.accion.record'),
      Modulo: [11],
    },
    {
      id: 6,
      Nombre: i18n.t('tipos.accion.accept'),
      Modulo: [11],
    },
    {
      id: 7,
      Nombre: i18n.t('tipos.accion.post_issued'),
      Modulo: [11],
    },
    {
      id: 8,
      Nombre: i18n.t('tipos.accion.reject_issued'),
      Modulo: [11],
    },
    {
      id: 9,
      Nombre: i18n.t('tipos.accion.pay_issued'),
      Modulo: [11],
    },
    {
      id: 10,
      Nombre: i18n.t('tipos.accion.cancel'),
      Modulo: [11],
    },
    {
      id: 11,
      Nombre: i18n.t('tipos.accion.move_to_error'),
      Modulo: [11],
    },
    {
      id: 12,
      Nombre: i18n.t('tipos.accion.query_invoice'),
      Modulo: [11],
    },
    {
      id: 13,
      Nombre: i18n.t('tipos.accion.move_to_duplicate'),
      Modulo: [11],
    },
    {
      id: 14,
      Nombre: i18n.t('tipos.accion.post_received'),
      Modulo: [0],
    },
    {
      id: 15,
      Nombre: i18n.t('tipos.accion.reject_received'),
      Modulo: [0],
    },
    {
      id: 16,
      Nombre: i18n.t('tipos.accion.pay_received'),
      Modulo: [0],
    },
    {
      id: 17,
      Nombre: i18n.t('tipos.accion.approve'),
      Modulo: [12],
    },
    {
      id: 18,
      Nombre: i18n.t('tipos.accion.send_to_erp'),
      Modulo: [2],
    },
    {
      id: 19,
      Nombre: i18n.t('tipos.accion.rectify_invoice'),
      Modulo: [11],
    },
    {
      id: 20,
      Nombre: i18n.t('tipos.accion.acept_quotation'),
      Modulo: [11],
    },
    {
      id: 21,
      Nombre: i18n.t('tipos.accion.cancel_quotation'),
      Modulo: [11],
    },
    {
      id: 22,
      Nombre: i18n.t('tipos.accion.convert_to_proforma'),
      Modulo: [11],
    },
    {
      id: 23,
      Nombre: i18n.t('tipos.accion.cancel_proforma'),
      Modulo: [11],
    },
    {
      id: 24,
      Nombre: i18n.t('tipos.accion.invoice'),
      Modulo: [11],
    },
    {
      id: 25,
      Nombre: i18n.t('tipos.accion.send_email'),
      Modulo: [11],
    },
    {
      id: 26,
      Nombre: i18n.t('tipos.accion.add_recurrence'),
      Modulo: [11],
    },

  ]
}

function GenerateTiposOperacion () {
  return [
    {
      id: 1,
      Nombre: i18n.t('verifactu.operations.alta'),
      Modulo: [31],
    },
    {
      id: 2,
      Nombre: i18n.t('verifactu.operations.correction'),
      Modulo: [31],
    },
    {
      id: 3,
      Nombre: i18n.t('verifactu.operations.reject'),
      Modulo: [31],
    },
    {
      id: 4,
      Nombre: i18n.t('verifactu.operations.cancellation'),
      Modulo: [31],
    },
    {
      id: 5,
      Nombre: i18n.t('verifactu.operations.without_registration'),
      Modulo: [31],
    },
    {
      id: 6,
      Nombre: i18n.t('verifactu.operations.cancellation_rejection'),
      Modulo: [31],
    },
  ]
}

function GenerateTiposCabecera () {
  return [
    {
      id: 1,
      menuId: 10, 
      Nombre: i18n.t('tipos.cabecera.not_sent')
    },
    {
      id: 2,
      menuId: 11, 
      Nombre: i18n.t('tipos.cabecera.sent')
    },
    {
      id: 3,
      menuId: 12, 
      Nombre: i18n.t('tipos.cabecera.on_error')
    },
    {
      id: 4,
      menuId: 13, 
      Nombre: i18n.t('tipos.cabecera.received')
    },
    {
      id: 6,
      menuId: 15, 
      Nombre: i18n.t('verifactu.register')
    },
    {
      id: 7,
      menuId: 17, 
      Nombre: i18n.t('tipos.cabecera.quotation_proforma')
    },
  ]
}

function CABECERAS_MODULOS (state) {
  return configHelper.getConfig(state, 'CABECERAS_MODULOS', GenerateCabecerasModulos)
}
function MODULOS (state) {
  return configHelper.getConfig(state, 'MODULOS', GenerateModulos)
}

function TIPOS_ESTADO (state) {
  return configHelper.getConfig(state, 'TIPOS_ESTADO', GenerateTiposEstado)
}
  
function TIPOS_ESTADO_RECEPCION (state) {
  return configHelper.getConfig(state, 'TIPOS_ESTADO_RECEPCION', GenerateTiposEstadoRecepcion)
}

function TIPOS_ESTADO_VERIFACTU (state) {
  return configHelper.getConfig(state, 'TIPOS_ESTADO_VERIFACTU', GenerateTiposVerifactu)
}
  
function TIPOS_ACCION (state) {
  return configHelper.getConfig(state, 'TIPOS_ACCION', GenerateTiposAccion)
}

function TIPOS_OPERACION (state) {
  return configHelper.getConfig(state, 'TIPOS_OPERACION', GenerateTiposOperacion)
}

function TIPOS_CABECERA (state) {
  return configHelper.getConfig(state, 'TIPOS_CABECERA', GenerateTiposCabecera)
}

export {
  CABECERAS_MODULOS, MODULOS, TIPOS_ESTADO, TIPOS_ESTADO_RECEPCION, TIPOS_ESTADO_VERIFACTU, TIPOS_ACCION, TIPOS_OPERACION, TIPOS_CABECERA
}

